/**
 * The one formatter for an order's receivedDate — every admin order surface
 * renders a Received column through it (AdminOrdersList's table,
 * AdminDashboard's dispatched list). The API carries receivedDate as an ISO
 * string, so parse before formatting (toLocaleDateString on a string is a
 * runtime crash) and fall back to the raw string when it is unparseable.
 * Callers thread their own locale options: the two surfaces intentionally
 * render different date styles.
 */
export const formatReceivedDate = (iso: string, options: Intl.DateTimeFormatOptions): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', options);
};
